export function ensureIsoDateWithTimeZone<T extends undefined | null | string>(date: T) {
    if (date === null || date === undefined) {
        return undefined;
    }

    if (date.includes('Z')) {
        return date;
    }

    return `${date}Z`;
}
